<template>
  <q-btn
    :disable="disable"
    :href="url"
    flat
    type="a"
    v-bind="$attrs"
    @click="onClick"
  >
    <template v-slot:default>
      <slot/>
    </template>
  </q-btn>
</template>

<script>
import { computeUrl, propsDef } from './btn.js'
import { router } from '@inertiajs/vue3'

export default {
  props: propsDef,
  setup (props) {
    const url = computeUrl(props)
    const hasHash = !props.routeHash && !props.href

    return {
      disable: props.disable,
      url: url,
      onClick: (e) => {
        if (hasHash) {
          e.preventDefault()
        } else {
          return
        }

        if (url) {
          router.visit(url)
        }
      },
    }
  },
}
</script>
